var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanksvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10671_44467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5108 21.0348L43.8449 0.389473C43.0235 -0.129824 41.9764 -0.129824 41.1551 0.389473L8.48907 21.0348C7.54162 21.6335 7.10433 22.7865 7.41578 23.8629C7.72739 24.9395 8.71319 25.6803 9.83396 25.6803H75.1658C76.2865 25.6803 77.2722 24.9395 77.5839 23.8629C77.8957 22.7865 77.4581 21.6335 76.5108 21.0348Z",
    fill: "#A1C1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8684 27.1875H62.1074C60.717 27.1875 59.5899 28.3146 59.5899 29.705V66.5762C59.5899 67.9666 60.717 69.0937 62.1074 69.0937H70.8684C72.2587 69.0937 73.3858 67.9666 73.3858 66.5762V29.705C73.3858 28.3146 72.2587 27.1875 70.8684 27.1875Z",
    fill: "#A1C1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8791 27.1875H38.1181C36.7277 27.1875 35.6007 28.3146 35.6007 29.705V66.5762C35.6007 67.9666 36.7277 69.0937 38.1181 69.0937H46.8791C48.2695 69.0937 49.3966 67.9666 49.3966 66.5762V29.705C49.3967 28.3146 48.2696 27.1875 46.8791 27.1875Z",
    fill: "#A1C1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7177 27.1875H13.9567C12.5663 27.1875 11.4392 28.3146 11.4392 29.705V66.5762C11.4392 67.9666 12.5663 69.0937 13.9567 69.0937H22.7177C24.1081 69.0937 25.2351 67.9666 25.2351 66.5762V29.705C25.2351 28.3146 24.1079 27.1875 22.7177 27.1875Z",
    fill: "#A1C1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7191 27.1836H18.3386V69.0911H22.7191C24.1088 69.0911 25.2365 67.9632 25.2365 66.5736V29.7011C25.2365 28.3113 24.1086 27.1836 22.7191 27.1836Z",
    fill: "#739FE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8363 20.6445H5.16809C2.58339 20.6445 0.480309 22.7475 0.480309 25.3323V30.1516C0.480309 32.7363 2.58323 34.8394 5.16809 34.8394H79.8364C82.4211 34.8394 84.5244 32.7364 84.5244 30.1516V25.3323C84.5242 22.7473 82.4211 20.6445 79.8363 20.6445Z",
    fill: "#739FE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1671 61.6445H9.83515C8.44477 61.6445 7.31769 62.7716 7.31769 64.162V73.3219C7.31769 74.7123 8.44477 75.8394 9.83515 75.8394H75.1669C76.5573 75.8394 77.6844 74.7123 77.6844 73.3219V64.162C77.6846 62.7716 76.5575 61.6445 75.1671 61.6445Z",
    fill: "#739FE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0062 70.8047H2.99706C1.60668 70.8047 0.479599 71.9318 0.479599 73.3221V82.4821C0.479599 83.8724 1.60668 84.9995 2.99706 84.9995H82.0061C83.3964 84.9995 84.5235 83.8724 84.5235 82.4821V73.3221C84.5237 71.9318 83.3964 70.8047 82.0062 70.8047Z",
    fill: "#537FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5836 23.8639C77.2731 24.9397 76.2862 25.6815 75.1651 25.6815H42.5V0C42.9665 0 43.4332 0.12916 43.8444 0.389307L75.8952 20.6465L76.5111 21.0358C77.4576 21.6335 77.8957 22.7865 77.5836 23.8639Z",
    fill: "#739FE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8696 27.1836H66.4893V69.0911H70.8696C72.2593 69.0911 73.387 67.9632 73.387 66.5736V29.7011C73.387 28.3113 72.2593 27.1836 70.8696 27.1836Z",
    fill: "#739FE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8803 27.1836H42.5V69.0911H46.8805C48.2702 69.0911 49.3979 67.9632 49.3979 66.5736V29.7011C49.3979 28.3113 48.27 27.1836 46.8803 27.1836Z",
    fill: "#739FE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5217 25.3359V30.1543C84.5217 32.7389 82.4188 34.8419 79.8341 34.8419H42.5V20.6484H79.8341C82.4188 20.6484 84.5217 22.7514 84.5217 25.3359Z",
    fill: "#537FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6825 64.162V73.3222C77.6825 74.712 76.5564 75.8397 75.1651 75.8397H42.5V61.6445H75.1651C76.5564 61.6445 77.6825 62.7723 77.6825 64.162Z",
    fill: "#537FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5217 73.3221V82.4824C84.5217 83.8721 83.3956 84.9999 82.0042 84.9999H42.5V70.8047H82.0042C83.3955 70.8047 84.5217 71.9308 84.5217 73.3221Z",
    fill: "#2B3C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10671_44467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanksvg);
export default __webpack_public_path__ + "static/media/banksvg.079b84f7c2f20d038b774c702db60f76.svg";
export { ForwardRef as ReactComponent };